<template>
  <div>
    <d-field label="Filemaker Organization ID" message="Leave empty to create a new record, or add an ID to update the record" rules="c_number_only">
      <d-input v-model="computedOrganization.filemakerOrganizationId" />
    </d-field>
    <d-field label="Company Name">
      <d-input v-model="computedOrganization.name" />
    </d-field>
    <d-field label="Business Type">
      <d-select v-model="computedOrganization.businessType" expanded>
        <option value="Corporation">
          Corporation
        </option>
        <option value="Partnership">
          Partnership
        </option>
        <option value="Sole Proprietorship">
          Sole Proprietorship
        </option>
        <option value="Other">
          Other
        </option>
      </d-select>
    </d-field>
    <d-field label="Address Line 1">
      <d-input v-model="computedOrganization.addressLine1" />
    </d-field>
    <d-field label="Address Line 2">
      <d-input v-model="computedOrganization.addressLine2" />
    </d-field>
    <d-field label="City">
      <d-input v-model="computedOrganization.city" />
    </d-field>
    <d-field label="State/Province">
      <d-input v-model="computedOrganization.state" />
    </d-field>
    <d-field label="Zip/Postal">
      <d-input v-model="computedOrganization.zip" />
    </d-field>
    <d-field label="Country">
      <d-input v-model="computedOrganization.country" />
    </d-field>
    <d-field label="Website URL">
      <d-input v-model="computedOrganization.websiteUrl" />
    </d-field>
    <d-field label="Email">
      <d-input v-model="computedOrganization.email" />
    </d-field>
    <d-field label="Phone #">
      <d-input v-model="computedOrganization.phone" />
    </d-field>
    <d-field label="Fax #">
      <d-input v-model="computedOrganization.fax" />
    </d-field>
  </div>
</template>

<script>
  export default {
    props: {
      organization: {
        type: Object,
        default: () => ({}),
      },
    },

    computed: {
      computedOrganization: {
        get() {
          return this.organization;
        },
        set(value) {
          this.$emit('update:organization', value);
        },
      },
    },
  };
</script>